import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/layouts/navbar/navbar.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { ChattingComponent } from './components/common/chatting/chatting.component';
import { HttpClientModule } from '@angular/common/http';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AgmCoreModule } from '@agm/core';
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';

import { HomeComponent } from './components/appviews/home/home.component';
import { SchoolsComponent } from './components/appviews/schools/schools.component';
import { RegisterTermsComponent } from './components/appviews/register/register-terms/register-terms.component';
import { RegisterDetailsComponent } from './components/appviews/register/register-details/register-details.component';
import { RegisterResultComponent } from './components/appviews/register/register-result/register-result.component';
import { StoryComponent } from './components/appviews/project_progress/story/story.component';
import { FounderComponent } from './components/appviews/project_progress/founder/founder.component';
import { ReasonComponent } from './components/appviews/project_progress/reason/reason.component';
import { TargetComponent } from './components/appviews/project_progress/target/target.component';
import { ResultComponent } from './components/appviews/project_progress/result/result.component';
import { ContactUsComponent } from './components/appviews/contact-us/contact-us.component';
import { Step1AboutComponent } from './components/appviews/parent_confirm/step1-about/step1-about.component';
import { Step2TermsComponent } from './components/appviews/parent_confirm/step2-terms/step2-terms.component';
import { Step3DetailsComponent } from './components/appviews/parent_confirm/step3-details/step3-details.component';
import { Step4LocationComponent } from './components/appviews/parent_confirm/step4-location/step4-location.component';
import { Step5DoneComponent } from './components/appviews/parent_confirm/step5-done/step5-done.component';
import { NotAvailableComponent } from './components/appviews/parent_confirm/not-available/not-available.component';
import { StudentDetailsComponent } from './components/appviews/student-details/student-details.component';
import { ChallengeCompetitionComponent } from './components/appviews/project_progress/challenge-competition/challenge-competition.component';
import { MethodologyComponent } from './components/appviews/project_progress/methodology/methodology.component';
import { OnlyNumberDirective } from './components/common/only-number.directive';
import { QuestionComponent } from './components/appviews/Question/question/question.component';
import { Methodology2Component } from './components/appviews/project_progress/methodology2/methodology2.component';
import { Methodology3Component } from './components/appviews/project_progress/methodology3/methodology3.component';
import { MovingStep1AboutComponent } from './components/appviews/moving_confirm/moving-step1-about/moving-step1-about.component';
import { MovingStep2TermsComponent } from './components/appviews/moving_confirm/moving-step2-terms/moving-step2-terms.component';
import { MovingStep3DetailsComponent } from './components/appviews/moving_confirm/moving-step3-details/moving-step3-details.component';
import { MovingStep4LocationComponent } from './components/appviews/moving_confirm/moving-step4-location/moving-step4-location.component';
import { MovingStep5DoneComponent } from './components/appviews/moving_confirm/moving-step5-done/moving-step5-done.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RegisterQutufDetailsComponent } from './components/appviews/register-qutuf/register-qutuf-details/register-qutuf-details.component';
import { RegisterQutufResultComponent } from './components/appviews/register-qutuf/register-qutuf-result/register-qutuf-result.component';
import { RegisterQutufTermsComponent } from './components/appviews/register-qutuf/register-qutuf-terms/register-qutuf-terms.component';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    PreloaderComponent,
 
    FooterComponent,
   
    ChattingComponent,
    HomeComponent,
    SchoolsComponent,
    RegisterTermsComponent,
    RegisterDetailsComponent,
    RegisterResultComponent,
    StoryComponent,
    FounderComponent,
    ReasonComponent,
    TargetComponent,
    ResultComponent,
    ContactUsComponent,
    Step1AboutComponent,
    Step2TermsComponent,
    Step3DetailsComponent,
    Step4LocationComponent,
    Step5DoneComponent,
        NotAvailableComponent,
    StudentDetailsComponent,
        ChallengeCompetitionComponent,
        QuestionComponent,
        MethodologyComponent,Methodology2Component,Methodology3Component, OnlyNumberDirective, MovingStep1AboutComponent, MovingStep2TermsComponent, MovingStep3DetailsComponent, MovingStep4LocationComponent, MovingStep5DoneComponent, RegisterQutufDetailsComponent, RegisterQutufResultComponent, RegisterQutufTermsComponent
  ],
  imports: [
      BrowserModule, FormsModule, HttpClientModule, BsDatepickerModule, BrowserAnimationsModule, MatTableModule, MatSlideToggleModule,
      ToastrModule.forRoot(),
      MatSortModule,
      MatPaginatorModule, MatChipsModule,
      AgmCoreModule.forRoot({
         // apiKey: 'AIzaSyAfIzbiX48h8Hr0S4uX-YPQHQAeV3CRsWw'
          apiKey: 'AIzaSyC0ymY9HgL622ZCcI9mw6o2pzoBJp4-LDQ'
      }),
    AppRoutingModule
  ],
    providers: [BsDatepickerConfig],
  bootstrap: [AppComponent]
})
export class AppModule { }
